import { useEffect, useState } from 'react';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';

import { setProjectElevation } from '../slices/systemSlice';

import type { AppDispatch, RootState } from '../store';
import { getElevation } from '../apis';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useCesiumElevation = (lon?: number, lat?: number) => {
  const dispatch = useDispatch();
  const [elevation, setElevation] = useState<number>();
  useEffect(() => {
    const run = async () => {
      if (typeof lon !== 'undefined' && typeof lat !== 'undefined') {
        const elevation = await getElevation(lon, lat);
        dispatch(setProjectElevation(elevation));
        setElevation(elevation);
      } else {
        dispatch(setProjectElevation(undefined));
        setElevation(undefined);
      }
    };
    run();
  }, [lon, lat]);
  return elevation;
};
